import { render, staticRenderFns } from "./LessonCenter.vue?vue&type=template&id=6f543dff&scoped=true&"
import script from "./LessonCenter.vue?vue&type=script&lang=js&"
export * from "./LessonCenter.vue?vue&type=script&lang=js&"
import style0 from "./LessonCenter.vue?vue&type=style&index=0&id=6f543dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f543dff",
  null
  
)

export default component.exports